import LookUpModel from "./LookUpModel";

export default class AgentiProvvModel extends LookUpModel {
    public readonly name: string = "";
    public readonly surname: string = "";
    public readonly idAgent: number = 0;
    public readonly member: string = "";

    constructor(data: Partial<AgentiProvvModel>) {
        super(data);

        this.update(data);
    }
}
